import { VIPER_CONST, VMVERSION } from "../commonConstant";
import { TAuth, ILogin, IAuth, IAuthLogin, IAuthLoginUser } from "../types";
import * as BaseApi from "../configs/api-config";

class LoginApiService {
  private url = (action: string) => VIPER_CONST.base_url + action;

  public async login(request: ILogin): Promise<IAuthLogin | undefined> {
    const body = {
      username: request.username,
      sessionid: request.sessionid,
      failstatus: 0,
      request: {
        username: request.username,
        password: request.password,
        privilege: request.privilege,
      },
    };
    return BaseApi._post(this.url("getauthorizedlogin"), body);
  }

  public async vmLogin(request: ILogin): Promise<IAuthLoginUser | undefined> {
    const body = {
      request: {
        username: request.username,
        password: request.password,
        version: VMVERSION,
      },
    };

    return BaseApi._post(this.url("vmlogin"), body);
  }

  public async userLogin(request: ILogin): Promise<IAuthLoginUser | undefined> {
    const body = {
      failstatus: 0,
      request: {
        username: request.username,
        password: request.password,
        marketid: "JAM",
        languageid: "en",
        getpaymentgateway: "Y",
      },
    };

    return BaseApi._post(this.url("login"), body);
  }
}
const AuthApi = new LoginApiService();
export default AuthApi;
